import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { apiUrl } from "environments/environment.helper";
import { map, Observable, of } from "rxjs";
import { AuthUtils } from "./auth.utils";

@Injectable({ providedIn: "root" })
export class AuthService {
  private readonly httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    // Use a raw HttpClient here to avoid DI recursion through app interceptors.
    this.httpClient = new HttpClient(httpBackend);
  }

  set accessToken(token: string) {
    localStorage.setItem("aemAccessToken", token);
  }

  get accessToken(): string {
    return localStorage.getItem("aemAccessToken") ?? "";
  }

  signIn(token: string): Observable<string> {
    return this.httpClient
      .post(`${apiUrl}/Account/Login`, null, {
        headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
        responseType: "text",
      })
      .pipe(
        map((result: string) => {
          localStorage.setItem("aemAccessToken", result);
          return result;
        })
      );
  }

  clearSession(): void {
    localStorage.removeItem("aemAccessToken");
    localStorage.removeItem("aemUser");
  }

  /**
   * Check the authentication status
   */
  check(): Observable<boolean> {
    const token = this.accessToken;

    // If no token is available, return false immediately
    if (!token) {
      return of(false);
    }

    // If the token is expired, return false immediately
    if (AuthUtils.isTokenExpired(token)) {
      return of(false);
    }

    // Token is available and valid, return true
    return of(true);
  }
}
